import AuthConfirm from '../../components/security/auth/authConfirm.container';
import { useParams } from 'react-router-dom';

const AuthConfirmPage = () => {
  let { token } = useParams();
  return <AuthConfirm temporalToken={token}></AuthConfirm>;
};

export default AuthConfirmPage;
